export default function TagEntryComponent({
  mention,
  theme,
  searchValue, // eslint-disable-line no-unused-vars
  isFocused, // eslint-disable-line no-unused-vars
  ...parentProps
}) {
  if (isFocused) {
    parentProps.className += ' mentionSuggestionEntryFocused';
  }
  return (
    // <div {...newParentProps}>
    <div {...parentProps}>
      <div style={{ width: '100%' }} className={`${theme.mentionSuggestionsEntryContainer}`}>
        <div className={theme.mentionSuggestionsEntryContainerLeft} />

        <div className={theme.mentionSuggestionsEntryContainerRight}>
          <div className={theme.mentionSuggestionsEntryText}>
            {mention.key !== 'createNewTag' ? mention.name : <div>+ Create New</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
